export default {
  question: (code) => `questionnaire/${code}`,
  feedback: "questionnaire/feedback/answers",
  feedbackDocument: "questionnaire/feedback/feedback_doc",
  questionnaireDocument: "questionnaire/questionnaire_doc",
  companyInformation: `company`,
};
